import { useEffect, useState } from 'react';
import Navbar from '../components/Navbar';

const host = process.env.REACT_APP_API_URL

function HomePage() {
  const [data, setData] = useState('');

  useEffect(() => {
    fetch(host + '/api/hello')
      .then(response => response.text())
      .then(text => setData(text))
      .catch(error => console.error('Error fetching data:', error));
  }, []);

  return (
    <div className="HomePage">
      <Navbar />
      {/* <h1>Fetched Text:</h1>
      <p>{data}</p> */}
    </div>
  );
}

export default HomePage;
